import { paths } from '@app/constants';
import i18n from '@app/i18n';

export const getSegmentedOptions = (isDependent = false) => {
  const options = [
    {
      label: i18n.t('profile_page.general'),
      value: `/${paths.app}/${paths.profile.root}/${paths.profile.general}`,
    },
    ...(!isDependent
      ? [
          {
            label: i18n.t('profile_page.password'),
            value: `/${paths.app}/${paths.profile.root}/${paths.profile.password}`,
          },
        ]
      : []),
    {
      label: i18n.t('profile_page.diseases'),
      value: `/${paths.app}/${paths.profile.root}/${paths.profile.diseases}`,
    },
    {
      label: i18n.t('profile_page.attributes'),
      value: `/${paths.app}/${paths.profile.root}/${paths.profile.attributes}`,
    },
    ...(!isDependent
      ? [
          {
            label: i18n.t('profile_page.notifications'),
            value: `/${paths.app}/${paths.profile.root}/${paths.profile.notifications}`,
          },
        ]
      : []),
    {
      label: i18n.t('profile_page.account'),
      value: `/${paths.app}/${paths.profile.root}/${paths.profile.account}`,
    },
  ];

  return options;
};
